exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-renderer .input-group-section {\n  background-color: #f2f2f2;\n}\n.input-group-renderer .input-group-section.disabled > .ant-collapse-header {\n  opacity: 0.3;\n}\n.input-group-renderer .ant-input-group {\n  margin: 0 !important;\n}\n", ""]);

// exports
